import React from "react";
import { MessageCircle, Phone, Mail, MapPin, Building2, CreditCard, Layers } from "lucide-react";

const GROUP_LINKS = [
  { href: "https://hebeh.com.mx", label: "HEBEH", subtitle: "Sitio corporativo", Icon: Building2 },
  { href: "https://tarjetas.hebeh.com.mx", label: "HEBEH Tarjetas", subtitle: "Soluciones de crédito", Icon: CreditCard },
  { href: "https://aceros.hebeh.com.mx", label: "HEBEH Aceros y Agregados", subtitle: "Materiales y acero", Icon: Layers },
];

export default function PremiumFooter({ business }) {
  const cfg = business || {};
  const whatsapp = cfg.whatsapp || "5539835137";
  const phone = cfg.phone || "55 1318 1745";
  const logoUrl = cfg.logoUrl;

  return (
    <footer
      className="relative border-t border-white/5 bg-[#050B12] pt-16 md:pt-20 pb-8"
      data-testid="premium-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            {logoUrl ? (
              <img src={logoUrl} alt="HEBEH" className="h-14 w-auto mb-6" />
            ) : (
              <div className="font-outfit font-bold text-white text-2xl mb-6">
                HEBEH <span className="text-[#F09A21]">Automotriz</span>
              </div>
            )}
            <p className="font-manrope text-slate-400 text-sm max-w-sm leading-relaxed">
              Autos nuevos con financiamiento a tu medida.
              Paga el enganche hasta el día de la entrega.
            </p>

            {/* Grupo HEBEH — pills con ícono */}
            <div className="mt-7" data-testid="footer-group">
              <p className="font-rajdhani font-medium text-[#3B82F6] text-[11px] tracking-[0.4em] uppercase mb-3">
                Grupo HEBEH
              </p>
              <div className="flex flex-wrap gap-2">
                {GROUP_LINKS.map(({ href, label, subtitle, Icon }) => (
                  <a
                    key={href}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={subtitle}
                    className="group inline-flex items-center gap-2 px-3 py-2 rounded-full border border-white/10 bg-white/5 hover:bg-white/10 hover:border-[#3B82F6]/60 transition-all"
                    data-testid={`group-link-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  >
                    <Icon className="w-3.5 h-3.5 text-[#3B82F6] group-hover:text-[#F09A21] transition-colors" strokeWidth={2} />
                    <span className="font-rajdhani font-medium text-white/85 group-hover:text-white text-xs tracking-wide">
                      {label}
                    </span>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-outfit font-medium text-white text-sm tracking-[0.2em] uppercase mb-5">
              Contáctanos
            </h4>
            <ul className="space-y-3 font-manrope text-slate-300 text-sm">
              <li>
                <a
                  href={`https://api.whatsapp.com/send?phone=${whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-3 hover:text-white transition-colors"
                >
                  <MessageCircle className="w-4 h-4 text-[#25D366]" />
                  WhatsApp {phone}
                </a>
              </li>
              <li>
                <a href={`tel:${whatsapp}`} className="inline-flex items-center gap-3 hover:text-white transition-colors">
                  <Phone className="w-4 h-4 text-[#F09A21]" />
                  {phone}
                </a>
              </li>
              <li className="inline-flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#3B82F6]" />
                contacto@hebeh.com.mx
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-slate-500 mt-0.5 flex-shrink-0" />
                <span className="leading-relaxed">
                  Av. Jaime Balmes No. 11,<br />
                  Torre B, Piso 4, Oficina 402,<br />
                  Colonia Polanco I Sección,<br />
                  Alcaldía Miguel Hidalgo,<br />
                  Ciudad de México, C.P. 11510
                </span>
              </li>
            </ul>
          </div>

          {/* CTA */}
          <div className="glass-panel rounded-2xl p-6">
            <p className="font-manrope text-xs tracking-[0.2em] text-[#F09A21] uppercase mb-3">
              ¿Listo para estrenar?
            </p>
            <p className="font-outfit font-light text-white text-2xl leading-tight mb-5">
              Tu auto nuevo puede estar aquí.
            </p>
            <a
              href={`https://api.whatsapp.com/send?phone=${whatsapp}&text=${encodeURIComponent("Hola, me interesa cotizar un auto")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#F09A21] text-[#0B1623] font-semibold text-sm hover:bg-[#ffb047] transition-colors"
              data-testid="footer-cta-whatsapp"
            >
              <MessageCircle className="w-4 h-4" />
              Escríbenos ahora
            </a>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="font-manrope text-xs text-slate-500">
            © 2026 HEBEH Automotriz. Todos los derechos reservados.
          </p>
          <p className="font-manrope text-xs text-slate-600">
            Precios y disponibilidad sujetos a cambio sin previo aviso.
          </p>
        </div>
      </div>
    </footer>
  );
}
